import queryString, { ParseOptions } from "query-string";

const parseOptions: ParseOptions = { arrayFormat: 'comma', arrayFormatSeparator: '|' };

export const featureFlags: any = {
  resetPassword: process.env.ENABLE_RESET_PASSWORD === 'true',
  minimumAccuracy: process.env.MINIMUM_ACCURACY,
  debug: process.env.ENABLE_DEBUG === 'true',
  displayUpdateModal: process.env.DISPLAY_UPDATE_MODAL === 'true',
  cameraZoom: process.env.ENABLE_CAMERA_ZOOM === 'true',
};

let queryStringFlags: any = getFeatureFlags();

export function getFeatureFlags (): any {
  const queryParams = queryString.parse(location.search, parseOptions);
  const featureFlagsUnsplitted = queryParams?.flags;

  const splitValue = (value: string) => {
    const [flag, flagValue] = value.split(',');
    return { [flag]: JSON.parse(flagValue) };
  };

  if (!Array.isArray(featureFlagsUnsplitted)) {
    return featureFlagsUnsplitted && splitValue(featureFlagsUnsplitted);
  }

  let featureFlags = {};
  featureFlagsUnsplitted.map((value: string) => {
    featureFlags = { ...featureFlags, ...splitValue(value) };
  });

  return featureFlags;
}

export function getFeatureFlag(flag: any): any {
  if (!queryStringFlags) {
    queryStringFlags = getFeatureFlags();
  }

  const urlValue = queryStringFlags && queryStringFlags[flag];
  const flagValue = featureFlags && featureFlags[flag];
  return urlValue || flagValue;
}